import { render, staticRenderFns } from "./OCTtlMain.html?vue&type=template&id=263375ce&scoped=true&"
import script from "./OCTtlMain.ts?vue&type=script&lang=ts&"
export * from "./OCTtlMain.ts?vue&type=script&lang=ts&"
import style0 from "./OCTtlMain.css?vue&type=style&index=0&id=263375ce&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "263375ce",
  null
  
)

export default component.exports